import React, { ReactElement, ReactNode } from 'react'
import { ButtonProps, Svg } from 'ui'
import { Button } from 'ui/Buttons'
import { ThemeUIStyleObject } from 'theme-ui'
import CheckmarkIconActive from 'images/plans/checkicon-active.svg'
import CheckmarkIconInactive from 'images/plans/checkicon-inactive.svg'

interface PaymentMethodButtonProps extends ButtonProps {
  isSelected: boolean
  children: ReactNode
  sxButton?: ThemeUIStyleObject
}
const PaymentMethodButton = ({
  isSelected,
  children,
  sxButton,
  ...props
}: PaymentMethodButtonProps): ReactElement => {
  return (
    <Button
      {...props}
      variant={isSelected ? 'transparent' : 'simple'}
      ariaLabel={`${isSelected ? 'Currently selected ' : 'Click to select '} ${children} `}
      sx={{
        width: '100%',
        position: 'relative',
        fontSize: '1.7rem',
        fontWeight: isSelected ? 700 : 500,
        backgroundColor: isSelected ? 'cyan800' : 'blueYonder10',
        justifyContent: 'center',
        alignItems: 'center',
        px: '0.8rem',
        height: '4.2rem',
        color: isSelected ? 'blue800' : 'aliceBlue70',
        border: '1px solid',
        borderColor: 'blue800',
        boxShadow:
          isSelected &&
          ((theme): string => {
            return `0px 0px 0px 2px ${theme.colors?.blue800}, 0px 0px 0px 4px #63D6FF`
          }),
        borderRadius: '3.2rem',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        svg: {
          opacity: isSelected ? 1 : 0.7,
        },
        '&:hover': {
          backgroundColor: isSelected ? 'cyan800' : 'blueYonder40',
        },
        ...sxButton,
      }}
    >
      <Svg
        svg={isSelected ? CheckmarkIconActive : CheckmarkIconInactive}
        sx={{
          flexShrink: 0,
          position: 'absolute',
          width: '2.4rem',
          height: '2.4rem',
          left: '1.2rem',
        }}
        descriptiveText={isSelected ? 'Selected payment method' : 'Unselected payment method'}
      />
      {children}
    </Button>
  )
}

export default PaymentMethodButton
